import React from "react";

export default function ProductBasicInfo({

    product,

    setProduct,

    categories = []

}) {

    const handleChange = (field, value) => {

        setProduct(prev => ({

            ...prev,

            [field]: value

        }));

    };

    const generateSlug = (value) => {

        const slug = value
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, "")
            .replace(/\s+/g, "-")
            .replace(/-+/g, "-");

        handleChange("title", value);

        handleChange("slug", slug);

    };

    return (

        <div
            style={{

                display: "flex",

                flexDirection: "column",

                gap: 24

            }}
        >

            <div>

                <h2
                    style={{
                        margin: 0,
                        marginBottom: 8
                    }}
                >
                    Basic Information
                </h2>

                <div
                    style={{
                        color: "#666",
                        fontSize: 14
                    }}
                >
                    This information will appear on your Marketplace product page.
                </div>

            </div>

            {/* Product Name */}

            <div>

                <label
                    style={{
                        display: "block",
                        fontWeight: 600,
                        marginBottom: 8
                    }}
                >
                    Product Name
                </label>

                <input

                    type="text"

                    value={product.title || ""}

                    onChange={(e) => generateSlug(e.target.value)}

                    placeholder="Example: Premium Wireless Headphones"

                    style={{

                        width: "100%",

                        padding: "14px",

                        borderRadius: 10,

                        border: "1px solid #ddd",

                        fontSize: 15,

                        boxSizing: "border-box"

                    }}

                />

            </div>

            {/* Slug */}

            <div>

                <label
                    style={{
                        display: "block",
                        fontWeight: 600,
                        marginBottom: 8
                    }}
                >
                    Product URL Slug
                </label>

                <input

                    type="text"

                    value={product.slug || ""}

                    onChange={(e) =>
                        handleChange("slug", e.target.value)
                    }

                    placeholder="premium-wireless-headphones"

                    style={{

                        width: "100%",

                        padding: "14px",

                        borderRadius: 10,

                        border: "1px solid #ddd",

                        fontSize: 15,

                        boxSizing: "border-box"

                    }}

                />

            </div>

            {/* Category */}

            <div>

                <label
                    style={{
                        display: "block",
                        fontWeight: 600,
                        marginBottom: 8
                    }}
                >
                    Category
                </label>

                <select

                    value={product.category || ""}

                    onChange={(e) =>
                        handleChange("category", e.target.value)
                    }

                    style={{

                        width: "100%",

                        padding: "14px",

                        borderRadius: 10,

                        border: "1px solid #ddd",

                        fontSize: 15,

                        boxSizing: "border-box"

                    }}

                >

                    <option value="">
                        Select Category
                    </option>

                    {categories.map(category => (

                        <option
                            key={category}
                            value={category}
                        >
                            {category}
                        </option>

                    ))}

                </select>

            </div>

            {/* Tags */}

            <div>

                <label
                    style={{
                        display: "block",
                        fontWeight: 600,
                        marginBottom: 8
                    }}
                >
                    Tags
                </label>

                <input

                    type="text"

                    value={product.tags || ""}

                    onChange={(e) =>
                        handleChange("tags", e.target.value)
                    }

                    placeholder="electronics, wireless, premium"

                    style={{

                        width: "100%",

                        padding: "14px",

                        borderRadius: 10,

                        border: "1px solid #ddd",

                        fontSize: 15,

                        boxSizing: "border-box"

                    }}

                />

                <div
                    style={{
                        marginTop: 6,
                        fontSize: 13,
                        color: "#777"
                    }}
                >
                    Separate multiple tags using commas.
                </div>

            </div>

            {/* Short Description */}

            <div>

                <label
                    style={{
                        display: "block",
                        fontWeight: 600,
                        marginBottom: 8
                    }}
                >
                    Short Description
                </label>

                <textarea

                    rows={3}

                    value={product.shortDescription || ""}

                    onChange={(e) =>
                        handleChange(
                            "shortDescription",
                            e.target.value
                        )
                    }

                    placeholder="A brief summary shown in product cards."

                    style={{

                        width: "100%",

                        padding: "14px",

                        borderRadius: 10,

                        border: "1px solid #ddd",

                        resize: "vertical",

                        fontSize: 15,

                        boxSizing: "border-box"

                    }}

                />

            </div>

            {/* Full Description */}

            <div>

                <label
                    style={{
                        display: "block",
                        fontWeight: 600,
                        marginBottom: 8
                    }}
                >
                    Full Description
                </label>

                <textarea

                    rows={8}

                    value={product.description || ""}

                    onChange={(e) =>
                        handleChange(
                            "description",
                            e.target.value
                        )
                    }

                    placeholder="Write a detailed description of your product."

                    style={{

                        width: "100%",

                        padding: "14px",

                        borderRadius: 10,

                        border: "1px solid #ddd",

                        resize: "vertical",

                        fontSize: 15,

                        boxSizing: "border-box"

                    }}

                />

            </div>

        </div>

    );

}